import React, { Component } from 'react'
import { FormGroup, FormControlLabel, Card, Switch, Dialog, DialogContent, IconButton } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import { FORM_ESTADO_CORTE_CEREAL } from '../../../../config/forms'
import { reduxForm, formValueSelector, Field } from 'redux-form'
import { CEREALES } from '../../../../config/cereales'
import { Button } from 'react-bootstrap'
import TextField from '@material-ui/core/TextField'
import { renderDateMaterialField } from '../../../Forms/fieldRenderers'
import Grid from '@material-ui/core/Grid'
import { required } from '../../../Forms/fieldValidators'
import moment from 'moment'
import 'moment/locale/es'

const selector = formValueSelector(FORM_ESTADO_CORTE_CEREAL)

let cortes = []
let cortesProgramados = []
const cerealesCalado = CEREALES.filter(cereal => cereal !== 'PELLETSJ' && cereal !== 'PELLETGC')
const HORAFINDECORTE = '01:00'

class SwitchCorteCereal extends Component {
  constructor (props) {
    super(props)
    this.openDialogCortes = this.openDialogCortes.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.submitCorte = this.submitCorte.bind(this)
    this.deleteCorte = this.deleteCorte.bind(this)
    this.showFechaExtension = this.showFechaExtension.bind(this)
    this.state = { show: false }
    this.state = { showFechaHasta: false }
    this.state = { vencimientoCorte: '' }
  }

  componentDidMount () {
    this.generarCortes()
    moment.locale()
  }

  submitCorte () {
    const { cerealCorte, change: formChange, fechaCorte, horaCorte, fechaHasta, corteGeneral } = this.props
    const generarFecha = moment(fechaCorte + ' ' + horaCorte, 'YYYY-MM-DD HH:mm')
    const fechaDeCorte = moment(generarFecha).format('YYYY-MM-DD HH:mm:ss')

    const fInicio = moment(fechaCorte, 'YYYY-MM-DD')
    const fFin = moment(fechaHasta, 'YYYY-MM-DD')
    const diasDeCorte = fFin.diff(fInicio, 'days')

    const diasParaCortar = []
    let f = fechaDeCorte

    for (let d = 0; d <= diasDeCorte; d++) {
      diasParaCortar.push(f)
      f = moment(f).format('YYYY-MM-DD')
      f = moment(f + ' ' + HORAFINDECORTE, 'YYYY-MM-DD HH:mm')
      f = moment(f).add(1, 'days').format('YYYY-MM-DD HH:mm:ss')
    }

    diasParaCortar.forEach(diaCorte => {
      if (cerealCorte.length > 1) {
        for (const c of cerealCorte) {
          const cereal = c.cereal
          this.props.submitCortePedido(diaCorte, cereal)
        }
        if (corteGeneral !== true) {
          formChange('corteGeneral', true)
        }
      } else if (cerealCorte.cereal) {
        const cereal = cerealCorte.cereal
        this.props.submitCortePedido(diaCorte, cereal)
      }
    })

    this.handleClose()
    formChange('cerealCorte', '')
    formChange('fechaCorte', '')
    formChange('horaCorte', '')
    this.generarCortes()
  }

  deleteCorte () {
    const { cerealCorte, change: formChange } = this.props

    if (cerealCorte.length > 1) {
      for (const c of cerealCorte) {
        if (c.vigente) {
          this.props.deleteCortePedido(c.fechaDeCorte, c.cereal)
        }
      }
    } else if (cerealCorte.cereal) {
      this.props.deleteCortePedido(cerealCorte.fechaDeCorte, cerealCorte.cereal)
    }

    this.handleClose()
    formChange('cerealCorte', '')
    formChange('fechaCorte', '')
    formChange('horaCorte', '')
    formChange('corteGeneral', false)
    this.generarCortes()
  }

  generarCortes () {
    const { cortesPedidos } = this.props
    cortes = []
    cortesProgramados = []
    if (cortesPedidos.length > 0) {
      cortesPedidos.map((corte) => {
        if (corte.activo) {
          cortes.push(corte)
        } else {
          cortesProgramados.push(corte)
        }
        return cortes
      }
      )
    }
    cerealesCalado.map((c) => {
      if (cortes.filter(corte => corte.cereal.trim() === c).length === 0) {
        const faltante = {
          fechaDeCorte: '',
          cereal: c,
          cerealNombre: c,
          vigente: false,
          activo: false
        }
        cortes.push(faltante)
      }
      return cortes
    })

    return cortes
  }

  openDialogCortes (cereal) {
    const { change: formChange } = this.props
    this.setState({ show: true })
    this.setState({ showFechaHasta: false })
    let fVencimiento
    formChange('cerealCorte', cereal && cereal)
    if (cereal.fechaDeCorte) {
      formChange('fechaCorte', moment(cereal.fechaDeCorte).format('YYYY-MM-DD HH:mm'))
      const generarVencimiento = moment(cereal.fechaDeCorte, 'YYYY-MM-DD')
      fVencimiento = moment(generarVencimiento).add(1, 'days').format('YYYY-MM-DD')
      console.log('programado', fVencimiento)
    } else {
      formChange('fechaCorte', moment().format('YYYY-MM-DD HH:mm'))
      fVencimiento = moment().add(1, 'days').format('YYYY-MM-DD')
      console.log('si no hay nada programado', fVencimiento)
    }
    formChange('fechaHasta', moment().format('YYYY-MM-DD HH:mm'))
    formChange('horaCorte', moment().format('HH:mm'))
    console.log('queda asi cuando lo paso', moment(fVencimiento).format('LL'))
    formChange('fechaVencimiento', moment(fVencimiento).format('LL'))
  }

  handleClose () {
    this.setState({ show: false })
  }

  changeFechaCorte (fecha) {
    const { change: formChange } = this.props
    const fechaCorte = moment(fecha).format('YYYY-MM-DD')
    formChange('fechaCorte', fechaCorte)
  }

  changeFechaHasta (fecha) {
    const { change: formChange } = this.props
    formChange('fechaHasta', fecha)
    formChange('fechaVencimiento', moment(fecha).add(1, 'days').format('LL'))
  }

  changeHoraCorte (e) {
    const { change: formChange } = this.props
    formChange('horaCorte', e.target.value)
  }

  showFechaExtension () {
    this.setState({ showFechaHasta: true })
  }

  render () {
    const {
      cortesPedidos,
      cerealCorte,
      fechaVencimiento,
      corteGeneral
    } = this.props

    this.generarCortes()

    return (
      <div>
        {cerealCorte && <Dialog
          open={this.state.show}
          onClose={this.handleClose}
          fullWidth
          maxWidth='xl'
        >
          <DialogContent style={{ padding: '5% 0', fontSize: '2.4rem', textAlign: 'center' }}>
            <div>
              <h4>Configuración de corte de producto</h4>
              { cerealCorte.length === 1 && <h3>Cereal: {cerealCorte.cereal}</h3> }
              { cerealCorte.length > 1 && <h3>Para todos los productos</h3> }
              <div className='container-cambio-fecha-corte'>
                <Grid className='field-fecha-hora'>
                  <Field
                    autoOk
                    name='fechaCorte'
                    emptyLabel
                    component={renderDateMaterialField}
                    autoFocus={false}
                    value={new Date()}
                    validate={[required]}
                    helperText='Inicio del corte'
                    disablePast
                    onChange={(f) => { this.changeFechaCorte(f) }}
                    placeholder={``}
                  />

                  <form noValidate>
                    <TextField
                      id='time'
                      type='time'
                      defaultValue={moment().format('HH:mm')}
                      label=''
                      onChange={(h) => { this.changeHoraCorte(h) }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                    />
                  </form>
                </Grid>
                {!this.state.showFechaHasta && <Button size='lg' className='button-cortes' onClick={this.showFechaExtension} >Extender corte</Button> }
                {this.state.showFechaHasta &&
                <Field
                  autoOk
                  name='fechaHasta'
                  emptyLabel
                  component={renderDateMaterialField}
                  autoFocus={false}
                  value={new Date()}
                  validate={[required]}
                  helperText='Último día del corte'
                  disablePast
                  onChange={(f) => { this.changeFechaHasta(f) }}
                  placeholder={``}
                />

                }
              </div>
            </div>
            <div>
              <h5>Fin de la vigencia del corte: <strong>{fechaVencimiento}</strong> a la <strong>{HORAFINDECORTE} hs.</strong></h5>
            </div>

          </DialogContent>
          <div className='container-buttons-cortes'>
            <Button size='lg' className='button-cortes' onClick={this.deleteCorte} >Anular corte</Button>
            <Button size='lg' className='button-cortes' onClick={this.handleClose} >Cancelar</Button>
            <Button size='lg' className='button-cortes' onClick={this.submitCorte} >Confirmar corte</Button>
          </div>
        </Dialog> }
        <Card style={{ paddingBottom: '4%' }}>
          <div className='card-header-corte-cereal'>
            <p className='nombre-cereal-corte'>Cereal</p>
            <p className='estado-cereal-corte'>Estado</p>
            <div className='programado-fecha-corte'>
              <p className='programado-cereal-corte' />
              <p className='fecha-corte-programado'>Fecha de corte</p>
            </div>
          </div>
          <FormGroup name='switches-corte-cereal' className='switches-corte-cereal'>
            {cortesPedidos && cortes.map((c) => (
              <div key={c.cereal}>
                <div className='info-corte-por-cereal'>
                  <p className='nombre-cereal-corte'>{c.cereal}</p>
                  <FormControlLabel className='estado-cereal-corte' key={c.fechaDeCorte} control={<Switch
                    color='primary'
                    name={c.cereal}
                    onClick={() => this.openDialogCortes(c)}
                    checked={c.activo}
                  />}
                  />
                  <div className='programado-fecha-corte'>
                    {c.vigente && !c.activo && <p className='programado-cereal-corte'>Programado</p>}
                    <p className='fecha-corte-programado'><strong>{c.fechaDeCorte}</strong></p>
                  </div>
                </div>
                <div className='cortes-programados'>
                  { cortesProgramados && cortesProgramados.map((cp) => (

                    (cp.cereal.trim() === c.cereal.trim()) ? <div className='fecha-cortes-programados' key={cp.fechaDeCorte}>
                      <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <IconButton onClick={() => this.openDialogCortes(cp)} ><EditIcon /></IconButton>
                        <p>Corte programado</p>
                      </div>
                      <p>{cp.fechaDeCorte}</p>
                    </div> : null
                  ))
                  }
                </div>
              </div>
            ))}
            {cortes && <div className='info-corte-por-cereal' key='corteGeneral'>
              <p className='nombre-cereal-corte'>Corte de todos los productos</p>
              <FormControlLabel className='estado-cereal-corte' key='corteGeneral' control={<Switch
                color='primary'
                name='corteGeneral'
                onClick={() => this.openDialogCortes(cortes)}
                checked={corteGeneral === true}
              />}
              />
            </div> }
          </FormGroup>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  corteGeneral: selector(state, 'corteGeneral'),
  cortesPedidos: state.camionesIngreso.cortesPedidos,
  cerealCorte: selector(state, 'cerealCorte'),
  fechaCorte: selector(state, 'fechaCorte'),
  fechaHasta: selector(state, 'fechaHasta'),
  fechaVencimiento: selector(state, 'fechaVencimiento'),
  horaCorte: selector(state, 'horaCorte')
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_ESTADO_CORTE_CEREAL,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(SwitchCorteCereal))
